import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../ModalView'
import Button from '../../Button'
import {ConfirmationModalViewProps} from './types'
import {ExclamationIcon} from '../../Icon'
import Modal from '../Modal'
import React from 'react'
import {useTranslation} from 'react-i18next'

const ConfirmationModalView = ({
    onCancel,
    onConfirm,
    text,
    title,
}: ConfirmationModalViewProps): React.ReactElement => {
    const {t} = useTranslation()

    return (
        <Modal onClose={onCancel}>
            <ModalHeader icon={ExclamationIcon} title={title} type='error' />
            <ModalContent>
                <div>{text}</div>
            </ModalContent>
            <ModalFooter>
                <Button onPress={onCancel} tabIndex={-1} text={t('Cancel')} />
                <Button color='filled' margin='left' onPress={onConfirm} tabIndex={0} text={t('OK')} />
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmationModalView
